import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import Avatar from "@mui/material/Avatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate, useLocation } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import DashboardIcon from '@mui/icons-material/Dashboard';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { useState } from 'react'
import { sidebarMenuItems } from "../constants";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { signOutUser } from "../slice/userSlice";
import { getAvatarContent } from "../utils/dashbaord";

const drawerWidth = 170;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: theme.palette.primary.main,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        backgroundColor: theme.palette.primary.main,

        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  "& .MuiDrawer-paper": {
    backgroundColor: theme.palette.primary.main, 
    color: "#fff", 
  },
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

export default function MiniDrawer() {
  const theme = useTheme();
  const path = window.location.pathname;
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(sidebarMenuItems?.findIndex(item => item.path === path) || 0); 
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.user || {});

  useEffect(() => {
    const currentIndex = sidebarMenuItems
      .map((item, index) => ({ index, match: location.pathname.startsWith(item.path) }))
      .filter(item => item.match)
      .sort((a, b) => b.index - a.index)[0]?.index;
  
    setActiveIndex(currentIndex !== undefined ? currentIndex : 0);
  }, [location.pathname]);
  
  const loggedInUser = user?.userName || "";

  const handleIconClick = (index, path) => {
    setActiveIndex(index); 
    navigate(path);  

  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  
  const handleSignOut = () => {
    dispatch(signOutUser());
    navigate("/login");
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* <CssBaseline /> */}
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={[
              {
                // marginRight: 5,
                color: "white",
              },
              open && { display: "none" },
            ]}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h5" noWrap component="div">
            ParcelAB Integrations
          </Typography>
          <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>

          <Button
            onClick={handleAvatarClick}
            sx={{ display: "flex", alignItems: "center", color: "white" }}
          >
            <Avatar sx={{ bgcolor: theme.palette.secondary.main, marginRight: 1 }}>
              <Typography variant="body1" sx={{ color: "white" }}>
                {getAvatarContent(loggedInUser)}
              </Typography>
            </Avatar>
            <Typography variant="body1" sx={{ color: "white" }}>
              {loggedInUser}
            </Typography>
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}         
          >
            <MenuItem  onClick={handleSignOut} >Sign Out</MenuItem>
          </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon className="text-white"/>
            ) : (
              <ChevronLeftIcon className="text-white"/>
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {sidebarMenuItems?.map((item, index) => (
          <ListItem key={item.text} disablePadding sx={{ display: 'block', px: 1.5 }}>
           <ListItemButton
            sx={[
            {
            minHeight: 5,
            px: 2,
            borderRadius: 2,
            py: 0.01,
            mb: 1,
            transition: 'all 0.3s ease', 
            },
          open ? { justifyContent: 'initial' } : { justifyContent: 'center' },
          activeIndex === index && {
            backgroundColor: theme.palette.secondary.main, 
            color: 'white', 
            '&:hover': {
              backgroundColor: theme.palette.secondary.main, 
            },
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.4)', 
          },
        ]}
        onClick={() => handleIconClick(index, item.path)}
       >
        <ListItemIcon
          key={index}
          sx={[
            { minWidth: 0, justifyContent: 'center', color: 'white' },
            open ? { mr: 1 } : { mr: 'auto' },
            activeIndex === index && { color: 'white' }, 
          ]}
        >
          {index % 3 === 0 ? (
            <DashboardIcon />
          ) : index % 3 === 1 ? (
             <LocalShippingIcon/>
            ) : (
            null
          )}
        </ListItemIcon>
         <ListItemText
          primary={item.text}
          sx={[
            open ? { opacity: 1, color: 'white' } : { opacity: 0 },
            activeIndex === index && { color: 'white' }, 
          ]}
         />
          </ListItemButton>
          </ListItem>
          ))}
        </List>

      </Drawer>
      {/* <Box component="main" sx={{ flexGrow: 1, pt: 13 }}>
        <DrawerHeader />
      </Box> */}
    </Box>
  );
}
